














































import { isEmail } from "@/utils/validate";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import { is_valid_email_domain } from "@/common/models/valid_email_domains";
import Vue from "vue";
export default Vue.extend({
  props: ["value"],
  setup(props, { emit }) {
    const initial_list_hash = ref("");
    const edited_email_list: Ref<string[]> = ref([]);
    const current_email = ref("");

    const is_valid_email = computed(() => {
      const email = current_email.value;
      const isValidPattern =
        isEmail(email) && is_valid_email_domain(email.split(".").pop() || "");
      return isValidPattern;
    });

    const is_existing_email = computed(() => {
      return edited_email_list.value.includes(current_email.value);
    });

    const has_changes = computed(() => {
      return (
        edited_email_list.value.sort().join(",") != initial_list_hash.value
      );
    });

    const add_email = () => {
      if (is_valid_email.value && !is_existing_email.value) {
        edited_email_list.value = [
          ...edited_email_list.value,
          current_email.value,
        ];
        current_email.value = "";
        emit("input", edited_email_list.value);
      }
    };

    const remove_email = (email: string) => {
      edited_email_list.value = edited_email_list.value.filter(
        (e) => e != email
      );
      emit("input", edited_email_list.value);
    };

    onMounted(() => {
      // @ts-ignore
      initial_list_hash.value = props.value.sort().join(",");
      // @ts-ignore
      edited_email_list.value = [...props.value];
    });
    return {
      remove_email,
      add_email,
      edited_email_list,
      current_email,
      is_valid_email,
      is_existing_email,
      has_changes,
    };
  },
});
